export default __webpack_public_path__ + "static/media/1.9e4b8923.png";